import React, { Component } from 'react';
import { Table } from 'react-bootstrap';

import { TheadExhibit1 as Thead } from './table-head.component';
import { TbodyExhibit1 as Tbody } from './table-body.component';
import Thead_CustomFilter from './thead-custom-filter.component';

import './table-component.css';
import { InventoryConfirmation } from '../../external/inventory/modal/inventory-confirmation.component';
import { ACTION_TYPES, TYPE_FUNCTION } from '../../../constants/external-constants';

// export class TableExhibit1 extends Component {
//     render() {
//         const { onColumnClick, columns, isNotSortable, rowClickAction, pageList, id } = this.props;
//         return (
//             <div className="table-container-wrapper">
//                 <Table className="table-fit" id={id}>
//                     <Thead onColumnClick={onColumnClick} columns={columns} isNotSortable={isNotSortable} />
//                     <Tbody key={'tbody-' + 'circuitKey'} rowClickAction={rowClickAction} columns={columns} pageList={pageList} />
//                 </Table>
//             </div>
//         );
//     }
// };

export class TableExhibit2 extends Component {
    enableUpdate(index){
        if (typeof this.props.deleteAction === TYPE_FUNCTION) { 
            this.props.deleteAction(index) 
        } else {
            alert("Function not available")
        }
    }
    render() {
        const {
            onColumnClick,
            onColumnSearch,
            onColumnSearchChange,
            isColSearchShow,
            columns,
            isNotSortable,
            rowClickAction,
            pageList,
            id,
            tableClassName,
            isLoading,
            showDetails,
            enableUpdate,
            deleteAction,
            noDataAvailable,
            noAvailableData,
            hideStatusIcon,
            columnFormatRendering,
            warningIconConfig,
            uniqueKeyProp
        } = this.props;
        return (
            <div className={`table-details-wrapper ${this.props.classNameWrapper ?? ""}`}>
                <Table className={`margin-bottom-0i ${tableClassName ?? ""}`} id={id}>
                    <Thead_CustomFilter onColumnClick={onColumnClick} onColumnSearch={onColumnSearch} onColumnSearchChange={onColumnSearchChange} isColSearchShow={isColSearchShow} columns={columns} isNotSortable={isNotSortable} />
                    <Tbody key={'tbody-' + 'circuitKey'} warningIconConfig={warningIconConfig} columnFormatRendering={columnFormatRendering} tablePaginationKey={this.props.tablePaginationKey} hideStatusIcon={hideStatusIcon} enableUpdate={enableUpdate} showDetails={showDetails} haveLink={this.props.haveLink} rowClickAction={rowClickAction} columns={columns} pageList={pageList} isLoading={isLoading} noDataAvailable={noDataAvailable} noAvailableData={noAvailableData} uniqueKeyProp={uniqueKeyProp} />
                </Table>

                <div className="delete-buttons-container">
                    {this.props.haveExternalDeleteBtn && 
                        pageList.map((item, index) => {                            
                            return(
                                <div key={index} className="delete-button-row">
                                    <InventoryConfirmation 
                                        actionType={this.props.deleteAction} 
                                        titleBtn={ACTION_TYPES.Delete}  
                                        updateNotifTitle={this.props.updateNotifTitle}
                                        confirmAction={()=> this.enableUpdate(index)}
                                    />                                    
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
};
